import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { Button } from "../Button";
import { PopupVideoDialog } from "./PopupVideoDialog";
import styles from "./PopupVideo.module.scss";
export const PopupVideo = ({ alignment, videoPlayer: VideoPlayer, label, theme, color, isInEditor, }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const togglePopup = useCallback(() => {
        setIsPopupOpen((prev) => !prev);
    }, []);
    const { toggleScroll } = useBodyScrollLock();
    useEffect(() => {
        toggleScroll(isPopupOpen);
    }, [isPopupOpen, toggleScroll]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(styles.buttonWrapper, {
                    [styles.center]: alignment === "center",
                    [styles.right]: alignment === "right",
                }), children: _jsx(Button, { theme: theme, variant: "cta", color: color, onClick: togglePopup, children: label }) }), isInEditor ? (VideoPlayer) : (_jsx(PopupVideoDialog, { videoPlayer: VideoPlayer, handleClose: togglePopup, isPopupOpen: isPopupOpen }))] }));
};
//# sourceMappingURL=PopupVideo.js.map